import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import clientReducer from './slices/clientSlice';
import clientUsageReducer from './slices/clientUsage';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        client: clientReducer,
        clientUsage: clientUsageReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
